import BaseLayer from "./BaseLayer";
import {drawLine} from "../utils/map_utils";
import {isTrue, notNull} from "utils/utils";

class TXTYPatternText extends BaseLayer {
    id = "txtyPatternText";
    label = "TXTY Pattern Text";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {scanMeta, textColor, textSize} = this.props;

        for (let key in scanMeta) {
            if (key.endsWith("_5"))
                continue;

            let {y_fields, tile_width, tile_height, uperpixel} = this.props.slide;
            
            let x = scanMeta[key]["col"];
            let y = scanMeta[key]["row"];
            y = y_fields - y - 1;
            
            if (notNull(scanMeta[key]["top"])){
                if (isTrue(scanMeta[key]["top"]["success"])) {
                    drawLine((x + 0.25) * (tile_width * uperpixel), (y + 1) * (tile_height * uperpixel), 1,
                        this.layer.getSource(), "tx=" + scanMeta[key]["top"]["tx"],
                        1, "#00ffea", "", textColor, textSize);
                    drawLine((x + 0.75) * (tile_width * uperpixel), (y + 1) * (tile_height * uperpixel), 1,
                        this.layer.getSource(), "ty=" + scanMeta[key]["top"]["ty"],
                        1, "#00ffea", "", textColor, textSize);
                }
            }
                
            if (notNull(scanMeta[key]["left"])) {
                if (isTrue(scanMeta[key]["left"]["success"])) {
                    drawLine(x * (tile_width * uperpixel), (y + 0.25) * (tile_height * uperpixel), 1,
                        this.layer.getSource(), "tx=" + scanMeta[key]["left"]["tx"],
                        1, "#00ffea", "", textColor, textSize);
                    drawLine(x * (tile_width * uperpixel), (y + 0.75) * (tile_height * uperpixel), 1,
                        this.layer.getSource(), "ty=" + scanMeta[key]["left"]["ty"],
                        1, "#00ffea", "", textColor, textSize);
                }
            }
                
        }
        resolve();
    });
}

export default TXTYPatternText;
